<div class="sidebar-backdrop" (click)="sidebarService.toogle()" *ngIf="sidebarService.isExpanded()"></div>
<div class="sidebar" style="min-height: 100% !important" [class.expanded]="sidebarService.isExpanded()">
        <div class="menu flex flex-column gap-2">
                <div class="flex flex-column gap-2 align-items-center justify-content-center mt-4 mb-4">
                        <img class="logo" src="/assets/images/logo-01.png" width="70">
                        <b class="company-name">CUIDACASA</b>
                </div>
                <p-panelMenu #menu [model]="items" styleClass="custom-menu"></p-panelMenu>
        </div>
</div>